import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-dialog-body-container',
	styleUrls: ['./dialog-body-container.component.scss'],
	templateUrl: './dialog-body-container.component.html',
	standalone: false,
})
export class DialogBodyContainerComponent {}
